import React from 'react';
import { Grid, Paper } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import CuestionarioTesisTorresTable from './CuestionarioTesisTorresTable';

export default function ListCuestionarioTesisTorres() {
  return (
    <DashboardLayout>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <CuestionarioTesisTorresTable />
        </Paper>
      </Grid>
    </DashboardLayout>
  );
}
